import type { PermissionKey } from "~/types/Permissions";

export const SRR_TITLE = [
  {
    label: "Возвращение автомобилей на ТО по месяцу контроля",
    value: "TOMonthOfControl",
  },
  {
    label: "Возвращение автомобилей на ТО по периоду продаж",
    value: "TOBySalesPeriod",
  },
  {
    label: " Возвращение автомобилей на гарантийный ремонт по месяцу контроля",
    value: "warrantyRepairMonthOfControl",
  },
  {
    label:
      "Возвращение автомобилей на гарантийный ремонт (свой-чужой) по месяцу контроля",
    value: "warrantyRepairBySalesPeriod",
  },
  {
    label: "Машинозаезды в динамике",
    value: "ReportReturnCarServiceDynamics",
  },
  {
    label: "Машинозаезды по дилеру",
    value: "ReportReturnCarServiceByDealer",
  },
  {
    label: "Среднесуточный пробег (семейство автомобиля-регион)",
    value: "ReportReturnCarAverageDailyMileageByMonth",
  },
  {
    label: "Клиенты не обращавшиеся на гарантийный ремонт",
    value: "ReportReturnClientsWithoutService",
  },
  {
    label: "SRR3",
    value: "SRR3",
  },
  {
    label: "SRR5",
    value: "SRR5",
  },
  {
    label: "Приглашение клиентов на ТО",
    value: "InvitationOfClientsForMaintenance",
  },
  {
    label: "Регистрация ГИБДД",
    value: "RegistrationOfTrafficPolice",
  },
  // {
  //   label: "UVIN",
  //   value: "reportReturnOfVehiclesForMaintenance",
  // },
  {
    label: "NS",
    value: "AverageDailyMileageReport",
  },
  {
    label: "1С УПП",
    value: "1c-ManagementManufacturingEnterprise",
  },
];

export const SRR_PERMISSION_MAP: Record<string, PermissionKey> = {
  TOMonthOfControl: "srr.returnTo.get",
  TOBySalesPeriod: "srr.returnTo.get",
  warrantyRepairMonthOfControl: "srr.returnTo.get",
  warrantyRepairBySalesPeriod: "srr.returnTo.get",
  ReportReturnCarServiceDynamics: "srr.carArrivals.get",
  ReportReturnCarServiceByDealer: "srr.carArrivals.get",
  ReportReturnCarAverageDailyMileageByMonth: "srr.family.get",
  ReportReturnClientsWithoutService: "srr.other.get",
  SRR3: "srr.ssr35.get",
  SRR5: "srr.ssr35.get",
  InvitationOfClientsForMaintenance: "srr.target.get",
  RegistrationOfTrafficPolice: "srr.gibdd.get",
  // reportReturnOfVehiclesForMaintenance: "srr.uvin.get", // TODO: при продолжении разработки разкомментировать
  // AverageDailyMileageReport: "srr.ns.get",              // TODO: при продолжении разработки разкомментировать
  "1c-ManagementManufacturingEnterprise": "srr.oneCSales.get",
};

export const MANAGMENT_MANUFACTURING_ENTERPRISE_TITLE = [
  {
    label: "1C УПП Средний чек материалов для ТО",
    value: "ReportAverageReceiptTO",
  },
  {
    label: "1С УПП Средний чек по АКС",
    value: "ReportReturnAverageReceiptAKC",
  },
];

export const SRR_TITLE_TO_MONTH_CONTROL = [
  {
    label: "Возвращение автомобилей на ТО (свой) по месяцу контроля",
    value: "TOMonthOfControlMine",
  },
  {
    label: "Возвращение автомобилей на ТО (свой-чужой) по месяцу контроля",
    value: "TOMonthOfControlFriendOrFoe",
  },
  {
    label:
      "Возвращение автомобилей на ТО (свой - чужой) по месяцу контроля по семейству автомобилей",
    value: "TOMonthOfControlFriendOrFoeByCarFamily",
  },
  {
    label: " Возвращение автомобилей на ТО (семейство автомобиля - регион)",
    value: "TOMonthOfControlCarFamilyRegion",
  },
];

export const SRR_TITLE_TO_MONTH_CONTROL_SALES_PERIOD = [
  {
    label: "Возвращение автомобилей на ТО (свой) по периоду продаж",
    value: "TOOwnBySalesPeriod",
  },
  {
    label: "Возвращение автомобилей на ТО (свой-чужой) по периоду продаж",
    value: "TOFriendOrFoeBySalesPeriod",
  },
  {
    label:
      "Возвращение автомобилей на ТО (свой - чужой) по периоду по семейству автомобилей",
    value: "TOFriendOrFoeByPeriodByCarFamily",
  },
  {
    label: "Возвращение автомобилей на ТО к дилерам LADA. Сводный отчет",
    value: "TOReturnCarForServiceByPeriodConsolidated",
  },
];

export const SRR3_TITLE = [
  {
    label: "SRR3 по дилерам LADA",
    value: "ReportReturnSRR3ByDealer",
  },
  {
    label: "SRR3 по дилерам LADA за период",
    value: "ReportReturnSRR3ByPeriod",
  },
  {
    label: "SRR3 по дилерам LADA для расчета премий",
    value: "ReportReturnSRR3ForPayments",
  },
  {
    label: "SRR3 по дилерам LADA по семействам автомобиля",
    value: "ReportReturnSRR3ByCar",
  },
  {
    label: "SRR3 по дилерам LADA — Расшифровка по VIN",
    value: "ReportReturnSRR3ByVIN",
  },
];

export const SRR5_TITLE = [
  {
    label: "SRR5 по дилерам LADA",
    value: "ReportReturnSRR5ByDealer",
  },
  {
    label: "SRR5 по дилерам LADA за период",
    value: "ReportReturnSRR5ByPeriod",
  },
  {
    label: "SRR5 по дилерам LADA для расчета премий",
    value: "ReportReturnSRR5ForPayments",
  },
  {
    label: "SRR5 по дилерам LADA по семействам автомобиля",
    value: "ReportReturnSRR5ByCar",
  },
  {
    label: "SRR5 по дилерам LADA — Расшифровка по VIN",
    value: "ReportReturnSRR5ByVIN",
  },
];

export const GIBDD_TITLE = [
  {
    label:
      "Возвращение автомобилей на ТО (свой) регистрация ГИБДД по месяцу контроля",
    value: "ReportReturnCarForServiceGIBDDByMonth",
  },
  {
    label:
      "Возвращение автомобилей на ТО (свой) регистрация ГИБДД по периоду продаж",
    value: "ReportReturnCarForServiceGIBDDByPeriod",
  },
  {
    label:
      "Возвращение автомобилей на ТО (свой-чужой) регистрация ГИБДД по месяцу контроля",
    value: "ReportReturnCarForeignForServiceGIBDDByMonth",
  },
  {
    label:
      "Возвращение автомобилей на ТО (свой-чужой) регистрация ГИБДД по периоду продаж",
    value: "ReportReturnCarForeignForServiceGIBDDByPeriod",
  },
  {
    label: "SRR3 регистрация ГИБДД по дилерам LADA",
    value: "ReportReturnSRR3GIBDDByDealer",
  },
  {
    label: "SRR3 регистрация ГИБДД по дилерам LADA за период",
    value: "ReportReturnSRR3GIBDDByPeriod",
  },
  {
    label: "SRR5 регистрация ГИБДД по дилерам LADA",
    value: "ReportReturnSRR5GIBDDByDealer",
  },
  {
    label: "SRR5 регистрация ГИБДД по дилерам LADA за период",
    value: "ReportReturnSRR5GIBDDByPeriod",
  },
];

export const UVIN_TITLE = [
  {
    label: "UVIN: уникальные обращения в сервис",
    value: "ReportReturnUniqueService",
  },
  {
    label: "UVIN – лояльность",
    value: "ReportReturnLoyaltyService",
  },
  {
    label: "UVIN – лояльность сводный по дилерам",
    value: "ReportReturnLoyaltyServiceByDealer",
  },
];

export const NS_TITLE = [
  {
    label: "NS по дилерам LADA",
    value: "ReportNSByDealer",
  },
  {
    label: "NS по дилерам с детализацией по продавцам-консультантам",
    value: "ReportNSByConsultant",
  },
  {
    label: "NS по клиентам",
    value: "ReportNSByClient",
  },
  {
    label: "NS по теплым клиентам",
    value: "ReportNSByWarmClients",
  },
  {
    label:
      "Количество и список клиентов, купивших последний а/м > 3х, 4х и 5лет",
    value: "ReportNSByOldClients",
  },
  {
    label: "Средний срок владения автомобилем",
    value: "ReportNSByAverageCarAge",
  },
  {
    label: "Работа с клиентами, продающими свой автомобиль",
    value: "ReportNSByClientCarSale",
  },
];

export const SRR_TO = [
  { label: "TO-0", value: "To0" },
  { label: "TO-1", value: "To1" },
  { label: "TO-2", value: "To2" },
  { label: "TO-3", value: "To3" },
  { label: "TO-4", value: "To4" },
  { label: "TO-5", value: "To5" },
  { label: "TO-6", value: "To6" },
  { label: "TO-7", value: "To7" },
  { label: "TO-8", value: "To8" },
];

export const SRR_GO = [
  { label: "ГО-1", value: "Go1" },
  { label: "ГО-2", value: "Go2" },
  { label: "ГО-3", value: "Go3" },
];

export const SRR_KIND_REPORT = [
  { label: "По периоду", value: "Period" },
  { label: "По виду ремонта", value: "Kind" },
  { label: "По семейству автомобиля", value: "FamilyCar" },
];

export const SRR_LOYALTY_TYPE = [
  { label: "свой (лояльность дилеру)", value: "Our" },
  { label: "чужой и свой (лояльность бренду)", value: "All" },
];

export const SRR_KINDS = [
  { label: "АГО", value: "Ago" },
  { label: "АТО", value: "Ato" },
  { label: "АКО", value: "Ako" },
  { label: "АСО", value: "Aso" },
  { label: "АНО", value: "Ano" },
  { label: "АКУ", value: "Aku" },
];

export const TABLE_REPORT_NO_GROUP = [
  "ReportReturnCarServiceDynamics",
  "ReportReturnCarAverageDailyMileageByMonth",
  "ReportReturnClientsWithoutService",
  "ReportReturnSRR3ByDealer",
  "ReportReturnSRR3ByPeriod",
  "InvitationOfClientsForMaintenance",
  "ReportReturnSRR3ForPayments",
  "ReportReturnSRR3ByCar",
  "ReportReturnSRR3ByVIN",
  "ReportReturnSRR5ByVIN",
  "ReportReturnSRR5ByDealer",
  "ReportReturnSRR5ByPeriod",
  "ReportReturnSRR5ForPayments",
  "ReportReturnSRR5ByCar",
  "ReportReturnSRR3GIBDDByDealer",
  "ReportReturnSRR5GIBDDByDealer",
  "ReportReturnSRR3GIBDDByPeriod",
  "ReportReturnSRR5GIBDDByPeriod",
  "TOReturnCarForServiceByPeriodConsolidated",
  "ReportReturnUniqueService",
  "ReportReturnLoyaltyService",
  "ReportReturnLoyaltyServiceByDealer",
  "ReportNSByDealer",
  "ReportNSByConsultant",
  "ReportNSByClient",
  "ReportNSByOldClients",
  "ReportNSByWarmClients",
  "ReportNSByAverageCarAge",
  "ReportNSByClientCarSale",
  "ReportAverageReceiptTO",
  "ReportReturnAverageReceiptAKC",
];

export const ARR_REPORT = [
  "TOMonthOfControl",
  "TOBySalesPeriod",
  "SRR3",
  "SRR5",
  "RegistrationOfTrafficPolice",
  // "reportReturnOfVehiclesForMaintenance",
  "AverageDailyMileageReport",
  "1c-ManagementManufacturingEnterprise",
];
